import { createRequestReducer } from "redux-request-state";

import * as actions from "./source.actions";

export const sources = createRequestReducer({
    begin: actions.REQUEST_SOURCES,
    success: actions.RECEIVE_SOURCES,
    failure: actions.ERROR_SOURCES
});